import { render, staticRenderFns } from "./PostingHeaderV2.vue?vue&type=template&id=6a4e281d"
import script from "./PostingHeaderV2.vue?vue&type=script&lang=ts"
export * from "./PostingHeaderV2.vue?vue&type=script&lang=ts"
import style0 from "./PostingHeaderV2.vue?vue&type=style&index=0&id=6a4e281d&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a4e281d')) {
      api.createRecord('6a4e281d', component.options)
    } else {
      api.reload('6a4e281d', component.options)
    }
    module.hot.accept("./PostingHeaderV2.vue?vue&type=template&id=6a4e281d", function () {
      api.rerender('6a4e281d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/postings/PostingHeaderV2.vue"
export default component.exports